/* eslint-disable */
<template>
  <div class="font-size-h3 text-default text-center">
    <span>
      Thank you for your booking request! Your appointment on
    </span>
    <span class="font-weight-bold">
      {{formattedStartDay}}, {{formattedStartDate}} at {{formattedStartTime}}
    </span>
    <span>
      has been confirmed. An email confirmation will be sent to you very shortly. We look forward to seeing you!
    </span>
  </div>
</template>

<script>
/* eslint-disable */
  import { BookingDateTimeMixin } from '@/mixins/Booking/BookingDateTimeMixin';
  
  export default {
    name: 'DisplayedApproved',
    mixins: [BookingDateTimeMixin]
  }
</script>